export const SEVERITY_CONFIG = {
  healthy: { label: "OK", icon: "check_circle", colorClass: "dark-green" },
  error: { label: "Errore", icon: "error", colorClass: "dark-red" },
  warning: { label: "Attenzione", icon: "warning", colorClass: "dark-orange" },
  stale: { label: "In ritardo", icon: "schedule", colorClass: "dark-orange" },
  stalled: { label: "Potenzialmente bloccato", icon: "hourglass_disabled", colorClass: "dark-red" },
  running: { label: "In esecuzione", icon: "sync", colorClass: "dark-blue" },
  disabled: { label: "Disattivato", icon: "pause_circle", colorClass: "gray" },
  unknown: { label: "Sconosciuto", icon: "help_outline", colorClass: "gray" },
};

export const SEVERITY_ORDER = {
  error: 0,
  stalled: 1,
  stale: 2,
  warning: 3,
  running: 4,
  unknown: 5,
  healthy: 6,
  disabled: 7,
};

export function severityConfig(severity) {
  return SEVERITY_CONFIG[severity] || SEVERITY_CONFIG.unknown;
}

export function formatDateTime(value) {
  if (!value) return "Mai";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Data non valida";
  return date.toLocaleString("it-IT");
}

export function formatRelativeTime(value) {
  if (!value) return "mai eseguito";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "data non valida";
  const seconds = Math.round((date.getTime() - Date.now()) / 1000);
  const formatter = new Intl.RelativeTimeFormat("it", { numeric: "auto" });
  const ranges = [
    [60, "second"],
    [60, "minute"],
    [24, "hour"],
    [7, "day"],
    [4.345, "week"],
    [12, "month"],
    [Number.POSITIVE_INFINITY, "year"],
  ];
  let valueToFormat = seconds;
  for (const [divisor, unit] of ranges) {
    if (Math.abs(valueToFormat) < divisor) {
      return formatter.format(Math.round(valueToFormat), unit);
    }
    valueToFormat /= divisor;
  }
  return formatter.format(Math.round(valueToFormat), "year");
}

export function formatDuration(value) {
  const milliseconds = Number(value);
  if (!Number.isFinite(milliseconds) || milliseconds < 0) return "N/D";
  if (milliseconds < 1000) return `${Math.round(milliseconds)} ms`;
  const seconds = milliseconds / 1000;
  if (seconds < 60) return `${seconds.toFixed(seconds < 10 ? 1 : 0)} s`;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  return `${minutes}m ${remainingSeconds}s`;
}

export function sortCronJobs(jobs) {
  return [...jobs].sort((left, right) => {
    const severityDifference =
      (SEVERITY_ORDER[left.severity] ?? 99) -
      (SEVERITY_ORDER[right.severity] ?? 99);
    if (severityDifference !== 0) return severityDifference;
    return String(left.label || left.key).localeCompare(
      String(right.label || right.key),
      "it",
    );
  });
}

export function isProblemSeverity(severity) {
  return ["error", "warning", "stale", "stalled", "unknown"].includes(severity);
}
